import React from 'react';
import DateRangeIcon from '@material-ui/icons/DateRange';
import IconButton from '@material-ui/core/IconButton';
import ScheduleIcon from '@material-ui/icons/Schedule';
import PrintIcon from '@material-ui/icons/Print';
import Tooltip from '@material-ui/core/Tooltip';

import { nameOrEmail } from '../../../utils/helper';
import IdentityLabel from '../../Common/IdentityLabel';
import getNoDataCellComponent from '../../Common/NoDataCellComponent';

import styles from '../styles';
import Grid from '../../Common/Grid';
import { GENERATE_LABELS_DIALOG } from '../../../redux/constants/dialogs';

const COLUMNS = [
  { name: 'reference', title: 'Reference' },
  { name: 'customer', title: 'Customer' },
  { name: 'primaryContact', title: 'Primary Contact' },
  { name: 'description', title: 'Description' },
  { name: 'tasks', title: 'Tasks' },
  { name: 'requested', title: 'Requested' },
  { name: 'allocated', title: 'Allocated' },
  { name: 'action', title: ' ' },
];

const COLUMN_EXTENSIONS = [
  { columnName: 'reference', width: 140 },
  { columnName: 'customer', width: 180 },
  { columnName: 'primaryContact', width: 150 },
  { columnName: 'tasks', width: 80 },
  { columnName: 'requested', width: 80 },
  { columnName: 'allocated', width: 80 },
  // { columnName: 'action', width: 150 },
  { columnName: 'action', width: 130 },
];

const getCellComponent = (date, onAssignResources, showDialog) => ({ row, column, value }) => {
  const jobDate = (row.dates || {})[date.format('Y-MM-DD')];
  switch (column.name) {
    case 'customer':
      return value.name;
    case 'primaryContact':
      return <IdentityLabel showDialog={showDialog} identity={value}/>;
    case 'tasks':
      return value ? value.count : 0;
    case 'requested':
      return jobDate ? (jobDate.resources || { requested: 0 }).requested : 0;
    case 'allocated':
      return jobDate ? (jobDate.resources || { allocated: 0 }).allocated : 0;
    case 'action':
      return (<span>
        {onAssignResources ? <Tooltip title="Assign Resources">
          <IconButton
            onClick={() => onAssignResources(row)}
          >
            <ScheduleIcon/>
          </IconButton>
        </Tooltip> : null}
        <Tooltip title="Print Labels">
          <IconButton
            onClick={() => showDialog(GENERATE_LABELS_DIALOG, { job: row })}
          >
            <PrintIcon/>
          </IconButton>
        </Tooltip>
          </span>);
    default :
      return value;
  }
};

class SchedulingGrid extends React.Component {
  render() {
    const { data, fetch, date, onEditJob, onAssignResources, showDialog } = this.props;

    return (<Grid
      columns={COLUMNS}
      columnExtensions={COLUMN_EXTENSIONS}
      cellComponent={getCellComponent(date, onAssignResources, showDialog)}
      data={data}
      fetch={fetch}
      onEdit={onEditJob}
      noDataCellComponent={getNoDataCellComponent(<DateRangeIcon style={styles.noData}/>, 'jobs')}
    />);
  }

}

export default SchedulingGrid;


// WEBPACK FOOTER //
// ./src/components/Scheduling/SchedulingGrid/index.js